import { FC, ReactNode, useMemo, CSSProperties } from 'react';
// 组件
import { ProTooltip, ProImage, } from '../antd';
import CopyText from '../CopyText';
// 方法
import classNames from 'classnames';
import { renderEnumName } from '../utils/renderUtils';
import { useLayoutContext } from '../PageLayout/context/LayoutContext';
// 常量
import { TABLE_COLUMN_EMPTY } from '../constants/constant';
import { LineRowProps, RenderType } from './interface';
import { TooltipProps } from 'antd/lib/tooltip';
import './style.less';

/** 行显示 */
const LineRow: FC<LineRowProps> = props => {
  const { columns, className, style, itemHeight } = props;
  const { enumData } = useLayoutContext();
  const renderText = (
    value?: ReactNode,
    enumCode?: string,
    copy?: boolean,
    tooltip?: string | TooltipProps,
    renderType?: RenderType,
  ) => {
    if (value === undefined) return TABLE_COLUMN_EMPTY;
    if (renderType === 'image' && typeof value === 'string') {
      return <ProImage className='yb-line-row-item-image' src={value} />;
    }
    if (enumCode && typeof value === 'string') {
      const enumItem = enumData?.[enumCode]?.items ?? [];
      return renderEnumName(value, enumItem);
    }
    if (copy && typeof value === 'string') {
      return <CopyText text={value} />;
    }
    if (tooltip) {
      if (typeof tooltip === 'string') {
        return (
          <ProTooltip placement="topLeft" title={tooltip}>
            {value}
          </ProTooltip>
        );
      }
      return (
        <ProTooltip placement="topLeft" {...tooltip}>
          {value}
        </ProTooltip>
      );
    }
    return value;
  };
  const classes = useMemo(() => {
    return classNames('yb-line-row', className);
  }, [className]);
  const itemStyle: CSSProperties | undefined = useMemo(() => {
    if (itemHeight && itemHeight !== 30) {
      return {
        height: itemHeight,
      };
    }
  }, [itemHeight]);
  return (
    <div className={classes} style={style}>
      {columns?.map((column, index) => {
        const { label, value, enumCode, copy, tooltip, renderType, } = column;
        return (
          <div
            className="yb-line-row-item"
            style={itemStyle}
            key={`${label ?? index}-${index}`}
          >
            {!!label && (
              <span className="yb-line-row-item-label">{label}:</span>
            )}
            <span className="yb-line-row-item-text">
              {renderText(value, enumCode, copy, tooltip, renderType)}
            </span>
          </div>
        );
      })}
    </div>
  );
};

LineRow.defaultProps = {
  itemHeight: 30,
};

export default LineRow;
